import { render, staticRenderFns } from "./WorkPositionTypePage.vue?vue&type=template&id=2d5ac94c&scoped=true&"
import script from "./WorkPositionTypePage.vue?vue&type=script&lang=js&"
export * from "./WorkPositionTypePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5ac94c",
  null
  
)

export default component.exports